import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Admin from './views/Admin.vue'
import AdminLogin from './views/AdminLogin.vue'
import Classroom from './views/Classroom.vue'
import Teacher from './views/Teacher.vue'
import Login from './views/Login.vue'
import Game from './views/Game.vue'
import Prize from './views/Prize.vue'
import Gacha from './views/Gacha.vue'
import SelectClass from './views/SelectClass.vue'
import Initialize from './views/Initialize.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    { path: '*', component: Home },

    {
      path: '/aqua_2019',
      name: 'home',
      component: Home,
      meta: {requiredAuth: true}
    },
    {
      path: '/aqua_2019/admin_login',
      name: 'adminLogin',
      component: AdminLogin
    },
    {
      path: '/aqua_2019/admin',
      name: 'admin',
      component: Admin,
      meta: { requiredAuthA: true }
    },
    {
      path: '/aqua_2019/teacher',
      name: 'class',
      component: Classroom
    },
    {
      path: '/aqua_2019/teacher/:classNum',
      name: 'teacherAd',
      component: Teacher,
      meta: { requiredAuthT: true }
    },
    {
      path: '/aqua_2019/login/:classNum',
      name: 'login',
      component: Login,
      meta: {requiredAuth: true}
    },
    {
      path: '/aqua_2019/gacha',
      name: 'gacha',
      component: Gacha,
      meta: {requiredAuth: true}
    },
    {
      path: '/aqua_2019/prize',
      name: 'prize',
      component: Prize,
      meta: {requiredAuth: true}
    },
    {
      path: '/aqua_2019/game',
      name: 'game',
      component: Game,
      meta: {requiredAuth: true}
    },
    {
      path: '/aqua_2019/selectClass',
      name: 'selectClass',
      component: SelectClass
    },


/*
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {requiredAuth: true}
    },
*/

    /*
    {
      path: '/aqua_2019/initialize',
      name: 'initialize',
      component: Initialize
    },
    */
/*
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { requiredAuthA: true }
    },
    {
      path: '/teacher',
      name: 'class',
      component: Classroom
    },
    {
      path: '/teacher/:classNum',
      name: 'teacherAd',
      component: Teacher,
      meta: { requiredAuthT: true }
    },
    {
      path: '/login/:classNum',
      name: 'login',
      component: Login,
      meta: {requiredAuth: true}
    },
    {
      path: '/gacha',
      name: 'gacha',
      component: Gacha,
      meta: {requiredAuth: true}
    },
    {
      path: '/prize',
      name: 'prize',
      component: Prize,
      meta: {requiredAuth: true}
    },
    {
      path: '/game',
      name: 'game',
      component: Game,
      meta: {requiredAuth: true}
    },
    {
      path: '/selectClass',
      name: 'selectClass',
      component: SelectClass
    }
    */

  ]
})
